import { IconPaths, KTSVG } from '../../../_metronic/helpers'
import styles from '../../modules/apps/atendimento_medicos/atendimento-video/aside/styles/aside-atendimento.module.css'

type RailItemProps = {
  icon: IconPaths
  title: string
  sub?: string
  onClick: () => void
  rightLabel?: string
  badge?: { text: string; cls: string }
}

export const RailItem: React.FC<RailItemProps> = ({
  icon,
  title,
  sub,
  onClick,
  rightLabel,
  badge,
}) => (
  <button type='button' className={styles.railItem} onClick={onClick} title={title}>
    <span className={styles.railIcon}>
      <KTSVG path={icon} />
    </span>
    <span className={styles.railTexts}>
      <span className='text-truncate fs-7 fw-semibold lh-sm text-gray-900'>{title}</span>
      {sub && <span className='text-truncate fs-8 text-gray-700'>{sub}</span>}
    </span>
    {badge ? (
      <span className={`badge ${badge.cls}`}>{badge.text}</span>
    ) : rightLabel ? (
      <span className='flex-shrink-0 fs-8 fw-semibold text-gray-700'>{rightLabel}</span>
    ) : (
      <KTSVG path={IconPaths.ArrowRight} className='flex-shrink-0 text-gray-500' />
    )}
  </button>
)
